import { render, staticRenderFns } from "./ShippingMethodInput.vue?vue&type=template&id=d13380fc&scoped=true"
import script from "./ShippingMethodInput.vue?vue&type=script&lang=js"
export * from "./ShippingMethodInput.vue?vue&type=script&lang=js"
import style0 from "./ShippingMethodInput.vue?vue&type=style&index=0&id=d13380fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13380fc",
  null
  
)

export default component.exports